import * as Types from "./mutation-types";
import {
  getDictionary,
  getDuesList,
  getBranchs,
  getZhiCheng,
  getDivisionData
} from "@/api/dictionary.js";
import { securityCheck } from "@/api/login.js";
import { setSessionStore } from "@/utils/sessionStorage";

const actions = {
  getDictionaryList({ commit, state }) {
    if (!state.dictionaryList.length) {
      getDictionary().then(res => {
        if (res.success) {
          commit(Types.SETDICTIONARY, res.result);
        }
      });
    }
  },
  getMemberTypeList({ commit, state }) {
    if (!state.memberTypeList.length) {
      getDuesList().then(res => {
        if (res.success) {
          commit(Types.SETMEMBERTYPE, res.result);
        }
      });
    }
  },
  getBranchsList({ commit, state }) {
    if (!state.branchsList.length) {
      getBranchs().then(res => {
        if (res.success) {
          commit(Types.SETBRANCHS, res.result);
        }
      });
    }
  },
  getZhiChengList({ commit, state }) {
    if (!state.zhichengList.length) {
      getZhiCheng().then(res => {
        commit(Types.SETZHICHENG, res.result);
      });
    }
  },
  getCityList({ commit, state }) {
    if (!state.cityList.length) {
      getDivisionData({
        level: "1"
      }).then(res => {
        commit(Types.SETCITY, res.result);
      });
    }
  },
  securityCheck({ commit }, userInfo) {
    const {
      username,
      password,
      grant_type,
      scope,
      client_id,
      client_secret
    } = userInfo;

    return new Promise((resolve, reject) => {
      securityCheck({
        username: username.trim(),
        password,
        grant_type,
        scope,
        client_id,
        client_secret
      })
        .then(res => {
          setSessionStore("access_token", res.access_token);
          setSessionStore("refresh_token", res.refresh_token);

          commit(Types.SETTOKEN, res.access_token);
          commit(Types.SETREFRESHTOKEN, res.refresh_token);
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  getGroupMemberType({
       commit,
       state
     }) {
    if (state.memberTypeList.length) {
      return
    }

    getGroupDues().then(res => {
      if (res.success) {
        commit(Types.SETMEMBERTYPE, res.result)
      }
    });
  },
  getPersonMemberType({
      commit,
      state
    }) {
    if (state.memberTypeList.length) {
      return
    }

    getDuesList().then(res => {
      if (res.success) {
        commit(Types.SETMEMBERTYPE, res.result)
      }
    });
  },

};

export default actions;
